import React, { Component, useState } from "react";
import { Rating } from 'react-simple-star-rating'
import { Link, withRouter } from "react-router-dom";
import agent_info from "../../../assets/images/agent_info.png";

const Agent_info = () => {
    const [ratingValue, setRatingValue] = useState(0) // initial rating 
    const handleRating = (rate) => {
        setRatingValue(rate)
    }
    const handleReset = () => {
        setRatingValue(4)
    }

    return (
        <div>
            <div className="agent_info_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="agent_detail_wrap">
                                <div className="agent_detail_area">
                                    <div className="left_area">
                                        <div className="image_area">
                                            <img src={agent_info} />
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="rating_area">
                                            <Rating
                                                ratingValue={ratingValue}
                                                showTooltip={true}
                                                initialValue={3.8}
                                                readonly
                                                tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                            />
                                        </div>
                                        <div className="detail_area">
                                            <h3>Cody Fisher</h3>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                                Mauris in sem at nisl luctus placerat nec in urna.</p>
                                        </div>
                                    </div>
                                    <div className="btn_area">
                                        <button className="btn-primary-4" >Contact now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Agent_info;


